export default class DoubleRangeSlider extends HTMLElement {
  connectedCallback() {
    const selectors = {
      fromSlider: ".from-slider",
      toSlider: ".to-slider",
      fromInput: ".from-input",
      toInput: ".to-input",
    };

    const fromSlider = this.querySelector(selectors.fromSlider);
    const toSlider = this.querySelector(selectors.toSlider);
    const fromInput = this.querySelector(selectors.fromInput);
    const toInput = this.querySelector(selectors.toInput);
    const theme = this.getAttribute("theme");

    if (!document.querySelector("double-range-slider")) {
      return;
    }

    fillSlider(fromSlider, toSlider, "#C6C6C6", theme, toSlider);
    setToggleAccessible(toSlider);

    fromSlider.addEventListener("input", () =>
      controlFromSlider(fromSlider, toSlider, fromInput)
    );
    toSlider.addEventListener("input", () =>
      controlToSlider(this, fromSlider, toSlider, toInput)
    );
    fromInput.addEventListener("input", () =>
      controlFromInput(fromSlider, fromInput, toInput, toSlider)
    );
    toInput.addEventListener("input", () => controlToInput(toSlider));

    function controlFromInput(controlSlider) {
      const [from, to] = getParsed(fromInput, toInput);
      fillSlider(fromInput, toInput, "#C6C6C6", theme, controlSlider);
      if (from > to) {
        fromSlider.value = to;
        fromInput.value = to;
      } else {
        fromSlider.value = from;
      }
    }

    function controlToInput(controlSlider) {
      const [from, to] = getParsed(fromInput, toInput);
      fillSlider(fromInput, toInput, "#C6C6C6", theme, controlSlider);
      setToggleAccessible(toInput);
      if (from <= to) {
        toSlider.value = to;
        toInput.value = to;
      } else {
        toInput.value = from;
      }
    }

    function controlFromSlider() {
      const [from, to] = getParsed(fromSlider, toSlider);
      fillSlider(fromSlider, toSlider, "#C6C6C6", theme, toSlider);
      if (from > to) {
        fromSlider.value = to;
        fromInput.value = to;
      } else {
        fromInput.value = from;
      }
    }

    function controlToSlider() {
      const [from, to] = getParsed(fromSlider, toSlider);
      fillSlider(fromSlider, toSlider, "#C6C6C6", theme, toSlider);
      setToggleAccessible(toSlider);
      if (from <= to) {
        toSlider.value = to;
        toInput.value = to;
      } else {
        toInput.value = from;
        toSlider.value = from;
      }
    }

    function getParsed(currentFrom, currentTo) {
      const from = parseInt(currentFrom.value, 10);
      const to = parseInt(currentTo.value, 10);
      return [from, to];
    }

    function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
      const rangeDistance = to.max - to.min;
      const fromPosition = from.value - to.min;
      const toPosition = to.value - to.min;
      controlSlider.style.background = `linear-gradient(
        to right,
        ${sliderColor} 0%,
        ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
        ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
        ${rangeColor} ${(toPosition / rangeDistance) * 100}%,
        ${sliderColor} ${(toPosition / rangeDistance) * 100}%,
        ${sliderColor} 100%)`;
    }

    function setToggleAccessible(currentTarget) {
      if (Number(currentTarget.value) <= 0) {
        toSlider.style.zIndex = 2;
      } else {
        toSlider.style.zIndex = 0;
      }
    }
  }
}
customElements.define("double-range-slider", DoubleRangeSlider);
